/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Estimatedticketsizemin4Inputs */

const en_coinvestments_prospects_estimatedticketsizemin4 = /** @type {(inputs: Coinvestments_Prospects_Estimatedticketsizemin4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Ticket Size Min.`)
};

/**
* | output |
* | --- |
* | "Est. Ticket Size Min." |
*
* @param {Coinvestments_Prospects_Estimatedticketsizemin4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_estimatedticketsizemin4 = /** @type {((inputs?: Coinvestments_Prospects_Estimatedticketsizemin4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Estimatedticketsizemin4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_estimatedticketsizemin4(inputs)
});
export { coinvestments_prospects_estimatedticketsizemin4 as "coInvestments_prospects_estimatedTicketSizeMin" }